import { globals } from "../../globals";
import { logOut } from "./auth";
//const history = createBrowserHistory();
// ------------------------------------
// Constants
// ------------------------------------
export const GET_CLIENT_DASHBOARD_START = "GET_CLIENT_DASHBOARD_START";
export const GET_CLIENT_DASHBOARD_SUCCESS = "GET_CLIENT_DASHBOARD_SUCCESS";
export const GET_CLIENT_DASHBOARD_FAILED = "GET_CLIENT_DASHBOARD_FAILED";
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  "Content-Type": "application/json",
};

export function getClientDashboard() {
  return (dispatch) => {
    dispatch({ type: GET_CLIENT_DASHBOARD_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };

    fetch(`${globals.apiUrl}/dashboard`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } 
        else if (response.status === 401) {
          dispatch(logOut());
        } 
        else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_CLIENT_DASHBOARD_FAILED, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_CLIENT_DASHBOARD_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_CLIENT_DASHBOARD_FAILED });
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_CLIENT_DASHBOARD_START]: (state) => {
    return {
      ...state,
      isFetchingDashboard: true,
    };
  },
  [GET_CLIENT_DASHBOARD_FAILED]: (state) => {
    return {
      ...state,
      isFetchingDashboard: false,
    };
  },
  [GET_CLIENT_DASHBOARD_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingDashboard: false,
      formDataValue: {
        clientResources: json.ResourceGroups,
        managementTools: json.ManagementTools,
        messages: json.Messages,
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  renderData: {},
  formDataValue: {
    clientResources: [],
    managementTools: [],
    messages: [],
  },
};

export default function clientDashboardReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientDashboard.js